import { render } from "./SmsIdentify.vue?vue&type=template&id=85698c10&scoped=true"
import script from "./SmsIdentify.vue?vue&type=script&lang=js"
export * from "./SmsIdentify.vue?vue&type=script&lang=js"

import "./SmsIdentify.vue?vue&type=style&index=0&id=85698c10&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85698c10"]])

export default __exports__